import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

declare var gtag: Function;
declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {

  private subscription: Subscription;

  constructor(private router: Router) { }

  public trackEvent(action: string, category: string, label: string = null, value: number = null) {
    if (this.subscription) {
      gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'value': value
      });
    }
  }

  public trackError(description: string, fatal: boolean = false) {
    if (this.subscription) {
      gtag('event', 'exception', {
        'description': description,
        'fatal': fatal
      });
    }
  }

  public subscribe() {
    if (!environment.production
      || window.location.hostname !== environment.hostname) return;
    if (!this.subscription) {
      this.subscription = this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          gtag('config', 'UA-69142110-5', { 'page_path': e.urlAfterRedirects });
        }
      });
    }
  }

  public unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
